'use client';

import {
	createContext,
	useContext,
	useRef,
	type RefObject,
	type ReactNode,
} from 'react';
import { Message } from '../message';

export const PromoMessageContext = createContext<{
	animate: boolean;
	scrollRef?: RefObject<HTMLDivElement | null>;
}>({ animate: false });

export function PromoMessage({
	text,
	answer = false,
	revealText = true,
	children,
}: {
	text: string;
	answer?: boolean;
	revealText?: boolean;
	children?: ReactNode;
}) {
	const context = useContext(PromoMessageContext);
	const animate = useRef(context.animate).current;
	return (
		<div className={animate ? 'ai-msg-enter' : undefined}>
			<Message
				m={{ role: answer ? 'you' : 'interviewer', time: '', text }}
				shouldAnimate={animate && !answer && revealText}
				scrollContainerRef={context.scrollRef}
			>
				{children}
			</Message>
		</div>
	);
}
